<template>
    <div class="home">
        <main-content />
    </div>
</template>

<script>
import mainContent from '@/components/product/index.vue'

export default {
    name: 'home',
    components: {
        mainContent
    }
}
</script>
